var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomThermostat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 28,
    viewBox: "0 0 43 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 43,
    height: 28,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 42,
    height: 27,
    x: 0.5,
    y: 0.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-fill",
    cx: 35.5,
    cy: 8.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-stroke",
    cx: 35.5,
    cy: 8.5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M5 5h24v18H5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M5.5 5.5h23v17h-23z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-fill",
    cx: 35.5,
    cy: 19.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-stroke",
    cx: 35.5,
    cy: 19.5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill-alt",
    d: "M9.694 19l3.766-8.302H8.434V9.662h6.37v.798L10.982 19H9.694zm6.272 0v-.924c3.36-2.646 5.18-4.2 5.18-5.81 0-1.19-.98-1.708-1.946-1.708-1.12 0-1.988.476-2.534 1.176l-.714-.742c.714-.938 1.932-1.47 3.248-1.47 1.554 0 3.136.882 3.136 2.744 0 1.904-1.932 3.64-4.536 5.698h4.578V19h-6.412z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-fill",
    cx: 24.5,
    cy: 10.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-svg-class": "RoomButton-stroke",
    cx: 24.5,
    cy: 10.5,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomThermostat);
export default __webpack_public_path__ + "static/media/RoomThermostat.abf87e5e08beb1196bbeb7fe00d65817.svg";
export { ForwardRef as ReactComponent };